import { createSelector } from 'reselect';
import CompliancePredesResdesDespatchesSummaryColumns from '../../containers/CompliancePredesResdesDespatchesSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.PREDES_RESDES_DESPATCHES_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.PREDES_RESDES_DESPATCHES_SUMMARY.isLoading;

export const getData =
  ReportDefinitions.PREDES_RESDES_DESPATCHES_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, CompliancePredesResdesDespatchesSummaryColumns);
